import {RemoteGetCheckFeatures} from 'data/usecases/private/check-features/remote-check-features';
import {GetCheckFeatures} from 'domain/usecases/private/check-features/get-check-features';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';

import {makeBFFApiUrl} from 'main/factories/http';
import {FeatureFlagEndpoint} from 'main/factories/usecases/endpoints';

export const makeGetCheckFeatures = (): GetCheckFeatures =>
	new RemoteGetCheckFeatures(
		makeBFFApiUrl(FeatureFlagEndpoint.featureFlag),
		makeAuthorizeHttpClientDecorator(),
	);
